<template>
  <div :class="['audio-player']">
    <div class="bg bg-left"></div>
    <div class="bg bg-right"></div>
    <div class="operation-line">
      <div class="player-content">
        <div
          class="play-btn"
          @click="playToggle()"
          :class="[isPlaying ? 'playing-btn' : '']"
          :data-rlog="!isPlaying ? `${rlogKey}_play_click` : `${rlogKey}_stop_click`"
        ></div>
        <div class="play-duration">
          <div class="duration">
            {{ formatTime((sliderValue * durationNumMultiple) / sliderNumMultiple, true) }}
          </div>
          <div class="slider">
            <a-slider
              class="process"
              @change="startSlider"
              @afterChange="endSlider"
              :tooltipVisible="false"
              v-model:value="sliderValue"
              :min="0"
              :max="duration * sliderNumMultiple"
            ></a-slider>
          </div>
          <div class="duration duration-right">
            {{ formatTime(duration * durationNumMultiple, true) }}
          </div>
        </div>
      </div>
      <slot></slot>
    </div>
  </div>
</template>

<script setup>
import { ref, watch, onUnmounted, defineEmits, defineProps, defineExpose } from 'vue';
import { useRefHooks } from '../../../utils/hooks';
import HowlerPlayer from '../../../utils/HowlerPlayer';
import { formatTime, getFloatByLen } from '../../../utils/utils';
import './AudioPlayer.scss';

const props = defineProps({
  src: String,
  rlogKey: {
    typeof: String,
    default: 'edit',
  },
});
const emit = defineEmits(['endSlider', 'playingCallback', 'beforePlay', 'beforePause']);
const isSlider = ref(false); // 是否正在拖动中
const curDuration = ref(0); // 当前播放位置
const duration = ref(0); // 视频总长 秒
const curRate = ref(1); // 播放速率
const [isPlaying, setIsPlaying] = useRefHooks(false);
const sliderNumMultiple = 100;
const durationNumMultiple = 1000;
const [sliderValue, setSliderValue] = useRefHooks(0);

function playingCallback(value) {
  emit('playingCallback', value);
}

// 改变当前进度
function changeCurDuration(newValue) {
  curDuration.value = getFloatByLen(newValue, 1);
}
let sound;
watch(
  () => props.src,
  () => {
    if (props.src) {
      sound = new HowlerPlayer({
        src: props.src,
        onload: () => {
          duration.value = sound.getDuration(); // 视频长度
        },
        onrate: value => {
          curRate.value = value; // 视频长度
        },
        setIsPlaying,
        duration: _duration => {
          // 监听播放过程，刷新当前进度 _duration
          if (isPlaying.value) {
            // 播放中且不是正在拖动进度条  && !isSlider.value
            changeCurDuration(_duration);
            playingCallback(_duration);
          }
        },
      });
    }
  },
  {
    immediate: true,
  }
);
watch(
  () => curDuration.value,
  newValue => {
    if (isSlider.value) {
      return;
    }
    setSliderValue(+newValue * sliderNumMultiple);
  },
  {
    immediate: true,
  }
);
// watch(
//   () => sliderValue.value,
//   newValue => {
//     console.log('sliderValue', newValue);
//   },
//   {
//     immediate: true,
//   }
// );
onUnmounted(() => {
  sound.destory();
  sound = null;
});
// 跳转到某位置
function seek(newValue) {
  // 秒
  changeCurDuration(newValue);
  sound.seek(newValue);
}
// 停止拖动
function endSlider() {
  isSlider.value = false;
  window._rlog.push(['_trackEvent', 'edit_play_drag']);
  seek(sliderValue.value / sliderNumMultiple);
  emit('endSlider', sliderValue.value / sliderNumMultiple);
}
// 开始拖动进度条
function startSlider(value) {
  isSlider.value = true;
}
function beforePlayOrPause(playStatus) {
  if (playStatus) {
    emit('beforePlay');
  } else {
    emit('beforePause');
  }
}
function toggle(value) {
  if (value !== undefined) {
    if (value) {
      sound.play();
    } else {
      sound.pause();
    }
    beforePlayOrPause(value);
  } else {
    beforePlayOrPause(!isPlaying.value);
    sound.toggle();
  }
}
function playToggle(value) {
  toggle(value, true);
}
function rate(value) {
  sound.rate(value);
}
defineExpose({ toggle, seek, isPlaying, rate, curDuration });
</script>
